import * as CustomFormats from '../moment/custom-formats';

/**
 * @example Sep 13, 1986
 */
export const DEFAULT = 'll';

/**
 * @example Sep 13, 1986 @ 8:30 PM
 */
export const DEFAULT_WITH_TIME = 'll @ LT';

/**
 * @example September 13, 1986
 */
export const FULL_MONTH_DEFAULT = 'LL';

/**
 * @example 09/13/1986
 */
export const TWO_DIGIT_STANDARD_DATE = 'L';

/**
 * @example 9/13/1986
 */
export const STANDARD_DATE = 'l';

/**
 * @example 9/13/1986 8:30 PM
 */
export const STANDARD_DATE_TIME_24 = 'l LT';

/**
 * @example 09/1986
 */
export const MONTH_YEAR = 'MM/YYYY';

/**
 * @example 13th
 */
export const DAY = 'Do';

/**
 * @example 1986-09-13
 */
export const ISO_8601_DATE_ONLY = 'Y-MM-DD';

/**
 * @example 1986-09-13T20:30:00.000-07:00
 */
export const ZONED_DATE_TIME = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

/**
 * @example 8:30 PM
 */
export const TIME_12_HOUR = 'LT';

/**
 * @example 1986-09
 */
export const YEAR_MONTH = 'YYYY-MM';

/**
 * @example 09/13/1986 at 8:30 PM
 */
export const TWO_DIGIT_STANDARD_DATE_AND_TIME_12_HOUR = `${TWO_DIGIT_STANDARD_DATE} [at] ${TIME_12_HOUR}`;
export const {
  MONTH_DAY,
  TWO_DIGIT_MONTH_DAY,
  WEEKDAY_MONTH_DAY_YEAR,
  WEEKDAY_MONTH_DAY
} = CustomFormats;
export default [DEFAULT, FULL_MONTH_DEFAULT, TWO_DIGIT_STANDARD_DATE, TWO_DIGIT_STANDARD_DATE_AND_TIME_12_HOUR, STANDARD_DATE, MONTH_DAY, TWO_DIGIT_MONTH_DAY, DAY, ISO_8601_DATE_ONLY, ZONED_DATE_TIME, TIME_12_HOUR, WEEKDAY_MONTH_DAY_YEAR, WEEKDAY_MONTH_DAY];